import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';

import CustomFieldAddFormProto from "../../add-form-proto";
import CustomFieldLeftPanel from "../../common/panel/form-left-panel";
import CustomFieldPreview from "../../common/form-preview";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";

export default class StringCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        // organizationId: PropTypes.string.isRequired,
        customField: PropTypes.object,
    }

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.PHONE;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.PHONE;

        result.params = {
            displayName : result.displayName?.trim(),
            scope       : result.scope
        };

        this.props.onSubmit(result);
    }

    render() {
        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview noPadding={true}>
                        <div className="gd-field-phone gd-custom-field-input-based preview m-l-5">
                            <div className="value">555 456 7893</div>
                            <div className="i5-phone"/>
                        </div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}/>
            </React.Fragment>
        )
    }
}